var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 281.613,
    height: 53.158,
    viewBox: "0 0 281.613 53.158",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_63271",
    "data-name": "Group 63271",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48560",
    "data-name": "Path 48560",
    d: "M9.921,11.452l-5.85,5.741s-9.415,10.043.389,20.179S20.3,53.843,20.3,53.843V41.228l-9.58-9.6s-3.71-3.946-.57-8.162C8.769,17.641,8.415,16.116,9.921,11.452Z",
    transform: "translate(0 -0.685)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48561",
    "data-name": "Path 48561",
    d: "M20.953.384,15.628,5.676s-9.686,9.66-1.241,19.82c6.47,6.637,6.566,6.907,6.566,6.907s4.158,3.409.524,8.252c.088,6.1.088,12.109.088,12.109l5.672-5.472s8.952-7.983,1.507-19.285l-7.888-7.892s-3-4.125.1-7.533C20.945,9,20.953.384,20.953.384Z",
    transform: "translate(-0.654 -0.022)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48562",
    "data-name": "Path 48562",
    d: "M20.953.384,15.628,5.676s-9.686,9.66-1.241,19.82c6.47,6.637,6.566,6.907,6.566,6.907s4.158,3.409.524,8.252c.088,6.1.088,12.109.088,12.109l5.672-5.472s8.952-7.983,1.507-19.285l-7.888-7.892s-3-4.125.1-7.533C20.945,9,20.953.384,20.953.384Z",
    transform: "translate(-0.654 -0.022)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48563",
    "data-name": "Path 48563",
    d: "M32.619,42.391l5.849-5.741S47.884,26.6,38.08,16.471,22.242,0,22.242,0V12.614l9.579,9.595s3.71,3.946.57,8.162C33.771,36.2,34.126,37.726,32.619,42.391Z",
    transform: "translate(-1.332)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48564",
    "data-name": "Path 48564",
    d: "M90.734,23.752l-6.213,17.4a6.969,6.969,0,0,1-2.539,3.488A6.683,6.683,0,0,1,78.164,45.7h-.578v-2.53h.578a4.5,4.5,0,0,0,2.69-.782,4.646,4.646,0,0,0,1.506-2.226l.553-1.574L77.531,23.752H80.22l3.944,11.105,3.883-11.105Z",
    transform: "translate(-4.642 -1.421)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48565",
    "data-name": "Path 48565",
    d: "M190.059,29.124v9.712H187.5V29.4a3.339,3.339,0,0,0-3.52-3.44c-1.264,0-2.09.448-3.707,2.079V38.835h-2.557V23.728h2.4l.033,1.412a5.877,5.877,0,0,1,4.156-1.789A5.578,5.578,0,0,1,190.059,29.124Z",
    transform: "translate(-10.642 -1.399)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48566",
    "data-name": "Path 48566",
    d: "M245.626,23.339c-4.093,0-6.741,3.1-6.741,7.9,0,4.817,2.7,7.931,6.886,7.931a8.111,8.111,0,0,0,4.966-1.583l.521-.4-1.3-1.851-.43.272a6.76,6.76,0,0,1-3.583,1.006h-.174a4.208,4.208,0,0,1-4.241-3.833h10.253l.087-.536a12.339,12.339,0,0,0,.153-1.923C252.029,25.883,249.7,23.339,245.626,23.339Zm3.924,7.151h-8.1c.164-2.9,1.713-4.609,4.2-4.609,2.661,0,3.9,1.324,3.9,4.165C249.562,30.19,249.56,30.336,249.55,30.49Z",
    transform: "translate(-14.304 -1.396)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48567",
    "data-name": "Path 48567",
    d: "M74.155,32.821c0,4.143-3.8,6-7.561,6-3.031,0-5.98-1.116-7.512-2.845l-.387-.438,1.655-2.1.435.5a8.088,8.088,0,0,0,5.848,2.176c2.231,0,4.831-.859,4.831-3.287,0-2.338-1.628-2.779-4.751-3.412-.278-.059-.562-.115-.848-.178-2.482-.522-6.237-1.315-6.237-5.689,0-4.161,3.815-6.023,7.6-6.023a10.716,10.716,0,0,1,5.922,1.684l.57.39-1.591,2.212-.434-.3a8.222,8.222,0,0,0-4.629-1.324c-2.391,0-4.8,1.016-4.8,3.286,0,1.871,1.425,2.518,4.238,3.12l.61.128C70.571,27.45,74.155,28.208,74.155,32.821Z",
    transform: "translate(-3.515 -1.049)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48568",
    "data-name": "Path 48568",
    d: "M107.309,29.124v9.712h-2.558V29.4a3.34,3.34,0,0,0-3.521-3.44c-1.266,0-2.089.448-3.711,2.079V38.835H94.963V23.728h2.4L97.4,25.14a5.878,5.878,0,0,1,4.155-1.789A5.58,5.58,0,0,1,107.309,29.124Z",
    transform: "translate(-5.687 -1.399)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48569",
    "data-name": "Path 48569",
    d: "M137.976,23.378V25.99l-.922-.012a4.407,4.407,0,0,0-3.739,2.39V38.836h-2.556V23.728h2.4l.033,1.451a5.762,5.762,0,0,1,4.036-1.813Z",
    transform: "translate(-7.831 -1.399)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48570",
    "data-name": "Path 48570",
    d: "M148.114,36.127h-2.465c-.82-.017-1.392-.359-1.392-.831,0-.276.22-.7.821-1.053a5.975,5.975,0,0,0,2.514.506c3.662,0,5.848-2.151,5.848-5.754a5.2,5.2,0,0,0-.817-2.927l1.833-.051v-2.3h-4.277a6.624,6.624,0,0,0-2.587-.484c-3.556,0-5.847,2.259-5.847,5.758a5.859,5.859,0,0,0,1.306,3.951A3.328,3.328,0,0,0,141.84,35.4a2.474,2.474,0,0,0,.973,1.958,4.292,4.292,0,0,0-1.624,3.625c0,3.011,2.605,4.88,6.8,4.88,3.182,0,6.586-1.28,6.586-4.878C154.58,36.127,149.716,36.127,148.114,36.127ZM147.591,25.8c1.021,0,3.4.311,3.4,3.2,0,2.78-2.128,3.193-3.4,3.193-1.552,0-3.4-.553-3.4-3.193C144.194,26.108,146.566,25.8,147.591,25.8Zm.167,17.539c-1.948,0-4.024-.618-4.024-2.35,0-1.443.647-2.339,3.887-2.339,3.326,0,4.392.567,4.392,2.339C152.014,42.718,149.815,43.336,147.759,43.336Z",
    transform: "translate(-8.457 -1.391)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48571",
    "data-name": "Path 48571",
    d: "M264.42,23.378V25.99l-.925-.012a4.4,4.4,0,0,0-3.734,2.39V38.836h-2.556V23.728h2.4l.036,1.451a5.751,5.751,0,0,1,4.035-1.813Z",
    transform: "translate(-15.401 -1.399)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48572",
    "data-name": "Path 48572",
    d: "M298.712,23.752l-6.21,17.4a6.97,6.97,0,0,1-2.541,3.488,6.688,6.688,0,0,1-3.819,1.061h-.578v-2.53h.578a4.5,4.5,0,0,0,2.692-.782,4.663,4.663,0,0,0,1.507-2.226l.553-1.574-5.382-14.838H288.2l3.946,11.105,3.885-11.105Z",
    transform: "translate(-17.099 -1.421)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48573",
    "data-name": "Path 48573",
    d: "M119.18,23.339c-4.1,0-6.743,3.1-6.743,7.9,0,4.817,2.7,7.931,6.888,7.931a8.1,8.1,0,0,0,4.966-1.583l.522-.4-1.3-1.851-.432.272a6.745,6.745,0,0,1-3.582,1.006h-.174a4.205,4.205,0,0,1-4.24-3.833h10.254l.086-.536a12.224,12.224,0,0,0,.154-1.923C125.584,25.883,123.25,23.339,119.18,23.339Zm3.926,7.151h-8.1c.162-2.9,1.715-4.609,4.2-4.609,2.663,0,3.9,1.324,3.9,4.165C123.117,30.19,123.111,30.336,123.106,30.49Z",
    transform: "translate(-6.732 -1.396)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48574",
    "data-name": "Path 48574",
    d: "M170.427,25.6a6.123,6.123,0,0,0-2.233-1.663,7.106,7.106,0,0,0-2.881-.572c-4.158,0-6.95,3.181-6.95,7.922s2.792,7.912,6.95,7.912c4.223,0,6.952-3.106,6.952-7.912A8.628,8.628,0,0,0,170.427,25.6Zm-9.508,5.687c0-3.282,1.684-5.317,4.394-5.317,2.755,0,4.4,1.987,4.4,5.317s-1.641,5.317-4.4,5.317C162.6,36.6,160.919,34.563,160.919,31.282Z",
    transform: "translate(-9.484 -1.399)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48575",
    "data-name": "Path 48575",
    d: "M206.962,20.572v5.972h8.43v2.69h-8.43v6.581h9.2v2.692H204.353V17.884h11.809v2.688Z",
    transform: "translate(-12.237 -1.071)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48576",
    "data-name": "Path 48576",
    d: "M233.753,29.124v9.712h-2.558V29.4a3.339,3.339,0,0,0-3.518-3.44c-1.265,0-2.091.448-3.708,2.079V38.835h-2.557V23.728h2.4l.033,1.412A5.874,5.874,0,0,1,228,23.351,5.578,5.578,0,0,1,233.753,29.124Z",
    transform: "translate(-13.26 -1.399)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48577",
    "data-name": "Path 48577",
    d: "M274.558,36.127h-2.463c-.821-.017-1.394-.359-1.394-.831,0-.276.22-.7.82-1.053a5.981,5.981,0,0,0,2.512.506c3.663,0,5.85-2.151,5.85-5.754a5.231,5.231,0,0,0-.814-2.927l1.832-.051v-2.3h-4.278a6.642,6.642,0,0,0-2.59-.484c-3.553,0-5.846,2.259-5.846,5.758a5.874,5.874,0,0,0,1.306,3.951,3.33,3.33,0,0,0-1.207,2.457,2.464,2.464,0,0,0,.973,1.958,4.28,4.28,0,0,0-1.625,3.625c0,3.011,2.6,4.88,6.8,4.88,3.184,0,6.589-1.28,6.589-4.878C281.026,36.127,276.16,36.127,274.558,36.127ZM274.032,25.8c1.025,0,3.4.311,3.4,3.2,0,2.78-2.127,3.193-3.4,3.193-1.547,0-3.4-.553-3.4-3.193C270.635,26.108,273.012,25.8,274.032,25.8Zm.168,17.539c-1.944,0-4.025-.618-4.025-2.35,0-1.443.651-2.339,3.887-2.339,3.326,0,4.394.567,4.394,2.339C278.458,42.718,276.26,43.336,274.2,43.336Z",
    transform: "translate(-16.026 -1.391)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.d05ba067f976f738d939008e95cb0e3c.svg";
export { ForwardRef as ReactComponent };